<template>
  <div class="grid-view charge-search-tab">
    <div class="main-content" style="overflow-y: auto;">
      <div class="section grid-wrapper">
        <cargo-ag-grid-wrapper
          config-module="185013"
          :grid-options="gridOptions"
          :export-file-name="$t(filename)"
          :column-defs="finalColumnDefs"
          :row-data="rowData"
          :per-config-name="perConfigName"
          :refresh-id="gridRefreshId"
          :show-row-groups="dataListDragGroup"
        />
      </div>
      <div id="footer-wrapper" class="pagination-wrapper amount-sum" style="flex-wrap: unset;align-items: unset;padding: 2px 5px;line-height: 28px;">
        <div style="display: flex;flex-direction: row-reverse;min-width: 600px">
          <charge-amount-sum-by-currency
            key="amountSumByCurrency"
            :data-provider="dataProvider"
            cache-prefix="BillTab"
            @callback="onSumCallbak"
          />
          <amount-sum-master-bold
            key="sumJobEquivalentRMB"
            ref="sumJobEquivalentRMB"
            datafield="CONVERT_TO_CNY_PROFIT"
            :title="$t('CargoMsg.Cargo_ConversionProfitCNYP')"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentPayable"
            ref="sumJobRmbEquivalentPayable"
            datafield="CONVERT_TO_CNY_AP"
            :title="$t('CargoMsg.Cargo_ConversionAPCNY') + ':'"
            :data-provider="rowData"
          />
          <amount-sum-master-bold
            key="sumJobRmbEquivalentReceiveable"
            ref="sumJobRmbEquivalentReceiveable"
            datafield="CONVERT_TO_CNY_AR"
            :title="$t('CargoMsg.Cargo_ConversionARCNY') + ':'"
            :data-provider="rowData"
          />
        </div>
        <!-- <amount-sum-master
          key="sumBillUnpaid"
          ref="sumBillUnpaid"
          datafield="AMOUNT_UN"
          :is-sum-visible="false"
          ar-data-field="AR"
          :data-provider="rowData"
          :is-ar="false"
          :title="$t('CargoMsg.Cargo_UnpaidP')"
        />
        <amount-sum-master
          key="sumBillNotReceived"
          ref="sumBillNotReceived"
          datafield="AMOUNT_UN"
          ar-data-field="AR"
          :is-ar="true"
          :data-provider="rowData"
          :is-sum-visible="false"
          :title="$t('CargoMsg.Cargo_NotCollectedP')"
        />
        <amount-sum-master
          key="sumBillPayable"
          ref="sumBillPayable"
          datafield="AMOUNT"
          :data-provider="rowData"
          :is-sum-visible="false"
          ar-data-field="AR"
          :is-ar="false"
          :title="$t('CargoMsg.Cargo_DuesP')"
        />
        <amount-sum-master
          key="sumBillReceivable"
          ref="sumBillReceivable"
          datafield="AMOUNT"
          ar-data-field="AR"
          :data-provider="rowData"
          :is-ar="true"
          :title="$t('CargoMsg.Cargo_ReceivableP')"
        /> -->
        <div style="flex-grow: 1;display: inline-flex;flex-wrap: wrap;">
          <template v-if="!showSumPop">
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsReceivable') }}</span>
              <div v-for="(item,index) in arCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
            <div style="display: inline-flex;flex-wrap: wrap;">
              <span>{{ $t('FinanceManage.CurrencyAccountsPayable') }}</span>
              <div v-for="(item,index) in apCurrencySum" :key="index">
                <span style="padding-right: 8px;">{{ item.currency }}</span>
                <span style="padding-right: 8px;color:gray;">{{ item.amount.toFixed(2) }}</span>
              </div>
            </div>
          </template>
        </div>
        <div style="display: inline-flex;min-width: 150px">
          <div>{{ $t('CargoMsg.Cargo_AllAmountP')+rowData.length }}</div>
          <div style="margin: 0px 10px;">{{ $t('CargoMsg.Cargo_SelectedItems',['['+numSelected+']']) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import AmountSumMasterBold from './AmountSumMasterBold'
import ChargeAmountSumByCurrency from './ChargeAmountSumByCurrency'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import { getGridSelected, recordSelectedStatus } from '@/utils/agGrid'
import FinanceChargeSerachHP from '@/views/cargo/v0/Clearing/FinanceChargeSerachHP.js'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import CargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'BillTab',
  components: { CargoAgGridWrapper, AmountSumMasterBold, ChargeAmountSumByCurrency },
  props: {
    filename: { type: String, default: '' },
    data: { type: Array, required: true },
    rowDataChanged: {
      type: Function, default: () => {
      }
    },
    perConfigName: { type: String, default: '' },
    gridRefreshId: { type: Number, default: 0 }
  },
  data() {
    return {
      loading: false,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        onRowDataChanged: this.rowDataChanged,
        context: {
          componentParent: this
        }
      },
      columnDefs: [],
      specialExpenseColumnDefs: [],
      rowData: [],
      dataProvider: [],
      amountSum: {
        sumBillReceivable: [],
        sumBillPayable: [],
        sumBillNotReceived: [],
        sumBillUnpaid: []
      },
      financeChargeSearchHP: new FinanceChargeSerachHP(this),
      numSelected: 0,
      showSumPop: false, // 是否显示合计弹窗
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      isSpecialExpenseEntryFunction: false, // 专项费用录入功能配置
      arCurrencySum: [],
      apCurrencySum: []
    }
  },
  computed: {
    finalColumnDefs() {
      if (this.isSpecialExpenseEntryFunction) {
        return [...this.columnDefs, ...this.specialExpenseColumnDefs]
      } else {
        return [...this.columnDefs]
      }
    }
  },
  watch: {
    data(newVal) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'UUID')
      this.rowData = newVal
      this.dataProvider = this.rowData
      selectedStatus.revert()
    }
  },
  created() {
    this.rowData = this.data
    this.dataProvider = this.rowData
    this.handleData(this.rowData)
    this.initConfig()
  },
  beforeMount() {
    this.gridOptions.onSelectionChanged = (event) => {
      this.onCheckBoxClick(event)
    }
    this.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'JOB_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'ACCOUNTID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
        } },
      { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'BUSINESS_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        } },
      { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'BILLINGNO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_BillingCurrency'), field: 'currency', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_BillingAmount'), field: 'AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_BillDate'), field: 'INPUTDATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        } },
      { headerName: this.$t('CargoMsg.Cargo_WrittenOff'), field: 'VERIFIED_AMOUNT', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('SeaExport.DateOfDelivery'), field: 'DELIVER_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      { headerName: this.$t('SeaExport.DateOfArrivalTheWarehouse'), field: 'ARRIVE_STORAGE_DATE', width: 180, enableRowGroup: true,
        cellRenderer: params => {
          return ColumnUtils.formateDateToString(params.value, 'yyyy-MM-dd')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_TotalOutstandingAmountByCurrency'), field: 'UN_VERIFIED_AMOUNT_DETAIL', width: 180, enableRowGroup: true,
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_NotWrittenOff'), field: 'AMOUNT_UN', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
        },
        summaryMode: 'sum' },
      { headerName: this.$t('CargoMsg.Cargo_BillType'), field: 'BILLINGTYPE', width: 180, enableRowGroup: true, cellRenderer: (params) => { return ColumnUtils.billingTypeLabFun(params.value) } },
      { headerName: this.$t('CargoMsg.Cargo_CounterpartySBillingNo'), field: 'COUNTER_PARTY_BILLING_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_AccountStatementNo'), field: 'BILLING_GROUP_BILLING_NO', width: 180, enableRowGroup: true },
      { headerName: this.$t('CargoMsg.Cargo_Documents'), field: 'DC_ID', width: 180, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      },
      { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'PONO', width: 180, hide: true, enableRowGroup: true },
      {
        headerName: this.$t('CargoMsg.Cargo_Carrier'), field: 'CARRIER_ID', width: 100, hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }
      },
      {
        headerName: this.$t('CargoMsg.Cargo_dispatchingPlace2'),
        field: 'DISCHARGING_PLACE',
        colId: 'DISCHARGING_PLACE',
        enableRowGroup: true,
        width: 120
      },
      {
        headerName: this.$t('CargoMsg.Cargo_actTakeTime'),
        field: 'ACT_TAKE_TIME',
        colId: 'ACT_TAKE_TIME',
        enableRowGroup: true,
        width: 120,
        cellRenderer: (params) => {
          return ColumnUtils.dateTimeLabelFunc(params.value)
        }
      },
      {
        headerName: this.$t('Invoice.invoice_receivablesInvoicingStatus'),
        colId: 'receivableInvoiceState',
        field: 'receivableInvoiceState',
        enableRowGroup: true,
        width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('Invoice.invoice_payablesInvoicingStatus'),
        colId: 'payableInvoiceState',
        field: 'payableInvoiceState',
        enableRowGroup: true,
        width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.receivableInvoiceStateLabelFunction(params.value)
        },
        hide: true
      },
      {
        headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'OVERSEA_OP', width: 180, colId: 'OVERSEA_OP', hide: true, enableRowGroup: true,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      }
    ]
    this.specialExpenseColumnDefs = [{
      headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableTotal'),
      colId: 'specialChargeApSum',
      field: 'specialChargeApSum',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableCurrency'),
      colId: 'specialChargeApCurrency',
      field: 'specialChargeApCurrency',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableTotal'),
      colId: 'specialChargeArSum',
      field: 'specialChargeArSum',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }, {
      headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableCurrency'),
      colId: 'specialChargeArCurrency',
      field: 'specialChargeArCurrency',
      hide: true,
      initialWidth: 100,
      enableRowGroup: true
    }]
  },
  methods: {
    onCheckBoxClick(event) {
      const selections = getGridSelected(this.gridOptions)
      this.numSelected = selections.length
      if (selections.length > 0) {
        this.loading = getLoading()
        this.handleData(selections)
        // this.$refs.sumBillReceivable.setDataProvider(this.amountSum.sumBillReceivable, event)
        // this.$refs.sumBillPayable.setDataProvider(this.amountSum.sumBillPayable, event)
        // this.$refs.sumBillNotReceived.setDataProvider(this.amountSum.sumBillNotReceived, event)
        // this.$refs.sumBillUnpaid.setDataProvider(this.amountSum.sumBillUnpaid, event)
        this.$refs.sumJobEquivalentRMB.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(selections)
        this.$refs.sumJobRmbEquivalentPayable.setDataProvider(selections)
        this.dataProvider = selections
        this.loading.close()
      } else {
        this.$nextTick(() => {
          this.loading = getLoading()
          const hasDisplay = []
          this.gridOptions.api.forEachNode(node => {
            if (node.data && node.displayed) {
              hasDisplay.push(node.data)
            }
          })
          if (hasDisplay.length > 0) {
            if (hasDisplay.length == this.rowData.length) {
              this.handleData(this.rowData)
            }
            if (hasDisplay.length < this.rowData.length) {
              this.handleData(hasDisplay)
            }
          } else {
            this.handleData(hasDisplay)
          }
          // this.$refs.sumBillReceivable.setDataProvider(this.amountSum.sumBillReceivable, event)
          // this.$refs.sumBillPayable.setDataProvider(this.amountSum.sumBillPayable, event)
          // this.$refs.sumBillNotReceived.setDataProvider(this.amountSum.sumBillNotReceived, event)
          // this.$refs.sumBillUnpaid.setDataProvider(this.amountSum.sumBillUnpaid, event)
          this.$refs.sumJobEquivalentRMB.setDataProvider(hasDisplay)
          this.$refs.sumJobRmbEquivalentReceiveable.setDataProvider(hasDisplay)
          this.$refs.sumJobRmbEquivalentPayable.setDataProvider(hasDisplay)
          this.dataProvider = hasDisplay.length > 0 ? hasDisplay : this.rowData
          this.loading.close()
        })
      }
    },
    handleData(source) {
      // this.amountSum.sumBillReceivable = source
      // this.amountSum.sumBillPayable = source
      // this.amountSum.sumBillNotReceived = this.financeChargeSearchHP.getUnverifiedAmountDetail(source, 'currency', 'AMOUNT_UN', 'AR')
      // this.amountSum.sumBillUnpaid = this.financeChargeSearchHP.getUnverifiedAmountDetail(source, 'currency', 'AMOUNT_UN', 'AR')
    },
    onSumCallbak(data) {
      this.showSumPop = data.showPop
      this.arCurrencySum = data.arCurrencySum
      this.apCurrencySum = data.apCurrencySum
    },
    async initConfig() {
      await cache.load(cacheName.CONFIG)
      this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
    }
  }
}
</script>

<style scoped>

</style>
